export const MEDICATIONS = {
  key: 'MEDICATIONS',
  value: 5,
  group: 2,
  title: 'health-record.medications.medication_title',
  menu_title: 'health-record.medications.title',
  sub_title: 'health-record.medications.medication-title-example',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Medications.svg'),
  list_title: 'Medication',
  icon: 'pill',
  editor: 'MedicationEditor',
  message_translate: 'health-record.medications.message',
  model_name: 'medication',
  resource: 'hr/medication/',
  plain_resource: 'medication',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.medications.medication',
      value: 'record.medication',
    },
    {
      text: 'health-record.medications.frequency',
      value: 'record.frequency_and_dosage',
    },
    {
      text: 'health-record.medications.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.medications.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      frequency_and_dosage: 'dosage',
      medication_stop_reason: {
        value: 'medication_stop_reason',
      },
      medication: 'medication',
      ingredient: 'ingredient',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #3949AB 3.07%, #5C6BC0 100%)',
  color: '#5767BE',
  opaque: '#D9DDEE',
}
